
import axios from 'axios';
import { BASE_API_URL } from './baseServices';
import { fetchWithAuth } from '../utils/api';

export const fetchOrganizations = async () => {
    try {
        const res = await fetchWithAuth(`ADMINRoutes/GetOrganzations`, {
            methodL: 'GET',
        });
        const data = await res.json();
        return data.ResultData;
    } catch (error) {
        console.error('Error fetching departments:', error);
        throw error;
    }
};

export const addOrganization = async (formData) => {
    return axios.post(`${BASE_API_URL}file_upload/CWIOrganization`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

export const updateOrganization = async (formData) => {
    return axios.post(`${BASE_API_URL}file_upload/CWIEditOrganization`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

export const inActiveOrganization = async (data) => {
    const payload = {
        ...data,
    };

    return axios.post(`${BASE_API_URL}ADMINRoutes/INACTIVEOrganization`, payload);
};
